import sri_lanka_chapter_1 from './sri_lanka_chapter_1.json'
import { lkQuizzStartChapt1 } from './sriLankaQuizzes'
import { lkLifeExpectancy, lkRabbies, lkReligion, lkEtnicity, lkWomenTravel } from './sriLankaGraphs'

const sriLankaObject = {
    country: 'Sri Lanka',
    link: 'sri-lanka',
    code: 'LK',
    lvl: 2,
    image: 'menu-travel.png',
    path: 'M1462.9,588.4c0,0,3.9,7.7,0.2,15.5c-3.7,7.7-3.2,17.4-2.5,21c0.6,2.8,3.6,21.6,4.7,29c3.7,7.1,7.6,6.2,8.4,5.9c3.8-1.4,4.6-1.5,12.8-2.1c6.9-0.5,8.5-6.4,9.7-9.2c0.2-0.2,1.5-20.2,0-21.3c-2.7-1.9-5.6-11.1-8.5-15.7c-2.8-4.3-2.2-4.6-4.7-8.3c-2.5-3.7-5.9-9.6-8.9-13.2c-6.6-0.3-7.5-3.3-9.4-5.1C1460.6,585.7,1462.9,588.4,1462.9,588.4z',
    locationMarker: 'M1472.8,518.2c-19.8,0-35.8,12.4-35.8,27.9c0,13.2,12,24.3,28,27.1c2,0.3,1.9,1.6,2.1,3.1l5.8,40l5.7-39.4c0.2-1.6,0.1-3.4,2.1-3.7c16-2.8,28.1-13.9,28.1-27.2C1508.6,530.6,1492.5,518.2,1472.8,518.2z',
    locationMarker2: 'M1530.6,573.4h-115.8c-8.1,0-14.5-6.6-14.5-14.5v-42c0-8.1,6.5-14.5,14.5-14.5h115.8c8.1,0,14.5,6.5,14.5,14.5v42C1545.2,566.8,1538.7,573.4,1530.6,573.4z',
    transform: 'matrix(1 0 0 1 1410.6816 548.3579)',
    coordinates: [
        7,
        80
    ],
    narratives: [
        {
            name: 'Capítulo 1',
            link: 'cap-1',
            file: sri_lanka_chapter_1,
            image: 'travel-responsive.png'
        },
        {
            name: 'Capítulo 2',
            link: 'cap-2',
            file: null,
            image: 'travel-responsive.png'
        },
        {
            name: 'Capítulo 3',
            link: 'cap-3',
            file: null,
            image: 'travel-responsive.png'
        }
    ],
    minigames: {
        crosswords: {
            across: {
                1: {
                    clue: 'one plus one',
                    answer: 'TWO',
                    row: 0,
                    col: 0,
                },
            },
            down: {
                2: {
                    clue: 'three minus two',
                    answer: 'ONE',
                    row: 0,
                    col: 2,
                }
            },
        },
        wordsearch: {
            lkTellFriendsActivities: [
                { word: 'Zeus', hint: 'Talvez o Deus grego mais conhecido' },
                { word: 'Atena', hint: 'Deusa que dá nome à cidade de Atenas' },
                { word: 'Apolo', hint: 'Nome que inspirou uma série de missões da NASA' },
                { word: 'Poseidon', hint: 'Normalmente associado ao mar, possui um tridente' }
            ]
        },
        quizzes: {
            lkQuizzStartChapt1
        }
    },
    news: {
        lkDengue: {
            headline: 'Á medida que casos dengue começam a subir gradualmente, o Sri Lanka luta contra um enimigo mortifero: mosquitos',
            content: 'test',
            src: 'https://www.reuters.com/article/us-sri-lanka-dengue-climatechange/as-dengue-cases-soar-sri-lanka-battles-a-deadly-foe-mosquitoes-idUSKBN1AD2KH'
        },
        lkTravelAloneInfo: {
            headline: 'Á medida que casos dengue começam a subir gradualmente, o Sri Lanka luta contra um enimigo mortifero: mosquitos',
            content: '',
            src: 'https://www.nytimes.com/2019/03/25/travel/solo-female-travel.html'
        },
        lkTigersOfTamilEelam: {
            headline: 'teste',
            content: 'teste',
            src: 'https://www.nytimes.com/2019/03/25/travel/solo-female-travel.html'
        }
    },
    info: {
        lkBudismTemples: {
            title: 'O budismo e as stupas',
            info: 'Teste stupa',
            src: 'https://www.britannica.com/topic/stupa'
        },
        lkStupaInfo: {
            title: 'O budismo e as stupas',
            info: 'Teste stupa',
            src: 'https://www.britannica.com/topic/stupa'
        },
        lkRabbiesInfo: {
            title: 'Epidemologia da Raiva',
            info: 'Rabies is estimated to cause 59 000 human deaths annually in over 150 countries, with 95% of cases occurring in Africa and Asia. Due to widespread underreporting and uncertain estimates, it is likely that this number is a gross underestimate of the true burden of disease. 99% of rabies cases are dog-mediated and the burden of disease is disproportionally borne by rural poor populations, with approximately half of cases attributable to children under 15.',
            src: 'https://www.who.int/rabies/epidemiology/en/'
        }
    },
    graphs: {
        lkLifeExpectancy,
        lkRabbies,
        lkReligion,
        lkEtnicity,
        lkWomenTravel
    }
}

export default sriLankaObject